import React from 'react';
import { POE_RJ45_COLORS, type PoeRj45Look } from '../../utils/poeRj45Look';

export function PoeRj45Marks({
  look,
  variant = 'corners',
}: {
  look: PoeRj45Look;
  size?: number;
  variant?: 'corners' | 'inline';
}) {
  if (look === 'data') return null;
  const showOut = look === 'poe-out' || look === 'poe-both';
  const showIn = look === 'poe-in' || look === 'poe-both';
  if (variant === 'inline') {
    return (
      <span className="inline-flex items-center gap-0.5 shrink-0" aria-hidden>
        {showIn ? <span className="port-poe-pip port-poe-pip-inline" style={{ background: POE_RJ45_COLORS.in }} /> : null}
        {showOut ? <span className="port-poe-pip port-poe-pip-inline" style={{ background: POE_RJ45_COLORS.out }} /> : null}
      </span>
    );
  }
  return (
    <>
      {showIn ? <span className="port-poe-pip port-poe-pip-in" aria-hidden /> : null}
      {showOut ? <span className="port-poe-pip port-poe-pip-out" aria-hidden /> : null}
    </>
  );
}
